module.exports = __webpack_public_path__ + "static/media/carta_preparativa_programacion_para_ninos.42b10e29.pdf";